(function() {

  // Force hero banner height to 85vh
  function setHeroStyles() {
    var frames = document.querySelectorAll('.image__hero__frame');
    frames.forEach(function(f) { f.style.setProperty('height', '85vh', 'important'); });
  }
  document.addEventListener('DOMContentLoaded', setHeroStyles);
  window.addEventListener('load', setHeroStyles);

  // Equalize product card title heights within each carousel/grid
  function equalizeProductTitles() {
    document.querySelectorAll('[data-carousel], .js-grid').forEach(function(container) {
      var titles = Array.from(container.querySelectorAll('.product__grid__title'));
      if (titles.length < 2) return;
      titles.forEach(function(t) { t.style.minHeight = ''; });
      var maxH = Math.max.apply(null, titles.map(function(t) { return t.offsetHeight; }));
      if (maxH > 0) titles.forEach(function(t) { t.style.minHeight = maxH + 'px'; });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    setTimeout(equalizeProductTitles, 300);
  });

  document.addEventListener('theme:resize', function() {
    setTimeout(equalizeProductTitles, 150);
  });

  // ─── Scroll-lock watchdog ─────────────────────────────────────────────────
  // The Postscript SMS popup locks body scroll (overflow:hidden + ps-scroll-lock)
  // but doesn't always release it after closing, freezing the page.
  // We watch the body directly and force-release when no overlay is visible.
  //
  // Grace period: Postscript applies the scroll lock slightly before its
  // popup markup finishes rendering. Without a grace period the watchdog can
  // fire in that gap, decide (wrongly) that nothing is open, and strip the
  // lock while Postscript is mid-render — which makes the popup close itself
  // before it's ever shown. We give it time to finish rendering first.
  var POSTSCRIPT_GRACE_MS = 2500;

  function isPostscriptOpen() {
    if (document.querySelector('.ps-popup, .ps-widget, [data-ps-popup], #postscript-subscriber-widget, .postscript-popup')) return true;
    // Postscript's widget markup/class names can vary by campaign, so also
    // match broadly on anything postscript-branded, including iframes.
    if (document.querySelector('[class*="postscript" i], [id*="postscript" i], iframe[src*="postscript.io" i]')) return true;
    // Custom elements such as <ps-popup> or <postscript-widget>.
    return Array.prototype.some.call(document.getElementsByTagName('*'), function(el) {
      return /^(ps|postscript)-/i.test(el.tagName);
    });
  }

  function isAnyOverlayOpen() {
    // Theme modals / drawers
    if (document.querySelector('.modal[aria-hidden="false"]')) return true;
    if (document.querySelector('[aria-modal="true"]')) return true;
    if (document.querySelector('[data-drawer].drawer--visible')) return true;
    if (document.querySelector('[data-drawer].is-open')) return true;
    if (document.querySelector('.popdown.is-visible')) return true;
    if (document.querySelector('.search-popdown.is-visible')) return true;
    if (document.querySelector('.popout-list--visible')) return true;
    if (window.theme && window.theme.state && window.theme.state.cartOpen) return true;
    // Postscript popup
    if (isPostscriptOpen()) return true;
    // Generic: any visible fixed overlay with a backdrop
    if (document.querySelector('.modal-overlay.is-visible, .overlay.is-visible')) return true;
    return false;
  }

  function forceReleaseScroll() {
    if (!isAnyOverlayOpen()) {
      // Release via theme event
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
      // Also directly restore body (catches Postscript's own lock)
      document.body.style.overflow = '';
      document.body.classList.remove('ps-scroll-lock');
      document.body.removeAttribute('data-scroll-lock');
      document.body.removeAttribute('data-scroll-lock-saved-overflow-y-property');
      document.body.removeAttribute('data-scroll-lock-saved-inline-overflow-y-property');
      document.documentElement.removeAttribute('data-scroll-locked');
    }
  }

  var lockCheckInterval = null;
  var lockStartedAt = null;

  function isBodyLocked() {
    return document.body.style.overflow === 'hidden' ||
           document.body.classList.contains('ps-scroll-lock') ||
           document.documentElement.hasAttribute('data-scroll-locked');
  }

  function startWatchdog() {
    clearInterval(lockCheckInterval);
    lockStartedAt = Date.now();
    lockCheckInterval = setInterval(function() {
      if (!isBodyLocked()) {
        clearInterval(lockCheckInterval);
        return;
      }
      if (Date.now() - lockStartedAt < POSTSCRIPT_GRACE_MS) return;
      forceReleaseScroll();
    }, 250);
  }

  // Watch the body for scroll lock being applied
  var bodyObserver = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (isBodyLocked()) {
        startWatchdog();
      } else {
        clearInterval(lockCheckInterval);
      }
    });
  });

  bodyObserver.observe(document.body, {
    attributes: true,
    attributeFilter: ['style', 'class', 'data-scroll-lock']
  });

  // Also watch <html> for data-scroll-locked
  var htmlObserver = new MutationObserver(function() {
    if (isBodyLocked()) startWatchdog();
    else clearInterval(lockCheckInterval);
  });
  htmlObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['data-scroll-locked']
  });

  // Escape key fallback
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') setTimeout(forceReleaseScroll, 400);
  });

})();
